'use client';

/**
 * 独立登录页路由（2026-10-08）：全站 `${BP}/login` 跳转的落点。
 * 此前详情页/内容广场点赞/payment 跳 `${BP}/login`，但应用内并无该路由
 * （staging 实测 404）——根路由 `/` 未登录态才渲染 LoginPage。
 *
 * 2026-10-10：
 * - theme="dialog"：与首页弹窗登录同款配色（此前画布紫色调与弹窗 emerald 不一致）
 * - 登录成功自动跳回：requireAuth 类跳转会带 ?next=<来源页>，本页监听
 *   auth:changed（或挂载时已登录）后跳回 next；无 next 时回画布。
 *   next 仅接受站内路径（以 / 开头且非 //），防开放重定向。
 */

import { useEffect } from 'react';
import { LoginPage } from '@/components/auth/LoginPage';
import { isAuthenticated } from '@/lib/api';

const BP = process.env.NEXT_PUBLIC_BASE_PATH || '';

function readNext(): string {
  try {
    const raw = new URLSearchParams(window.location.search).get('next') || '';
    if (raw.startsWith('/') && !raw.startsWith('//')) return raw;
  } catch {
    /* ignore */
  }
  return `${BP}/aigc`;
}

function safeJump(): void {
  // 同帧可能重复触发（auth:changed + 已登录检查），跳转后卸载监听由页面导航自然终结
  window.location.href = readNext();
}

export default function LoginPageRoute() {
  useEffect(() => {
    if (isAuthenticated()) {
      safeJump();
      return;
    }
    const onAuth = () => {
      if (isAuthenticated()) safeJump();
    };
    window.addEventListener('auth:changed', onAuth);
    return () => window.removeEventListener('auth:changed', onAuth);
  }, []);

  return <LoginPage theme="dialog" />;
}
